import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../global.service';

@Component({
  selector: 'app-club-terms',
  templateUrl: './club-terms.component.html',
  styleUrls: ['./club-terms.component.sass']
})
export class ClubTermsComponent implements OnInit {
  public tabActive='Mis Equipos y Servicios';
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public selectBan;
  public token:string=sessionStorage.getItem("token");
  public content:object;
  constructor(public global:GlobalService) { }

  ngOnInit() {
    this.content={
      content:[
        {
          title:"El programa Claro Club",
          description:"a) Claro Club (el “Programa”) ofrecerá a cada cliente suscrito a un servicio con Puerto Rico Telephone Company, Inc. (“Claro”) como, pero sin limitarse a, móvil (pospago/prepago), línea residencial, internet o <a class='ClaroTv'>Claro</a><a class='tvmas'>tv+</a>  (un “Cliente”) la oportunidad de obtener recompensas, regalos o acumular dinero. El dinero acumulado por el Cliente en el Programa podrá ser redimido mediante reembolso directo a su cuenta bancaria o a su cuenta de PayPal, según elija. Todos los servicios del Programa serán tramitados a través de la aplicación móvil BUREA (“BUREA”) de Better Ideas, LLC. (“Better Ideas”) en cualquier plataforma en la cual esté disponible.<br><br>b) Todo Cliente de Claro que interese participar de Claro Club podrá suscribiré a través de BUREA, aceptando los términos y condiciones del Programa.",
          expand:true
        }
      ]
    };
  }
  initializeData(){
    this.global.refreshDataTo(this.token);
  }
}
